import {
  areCoveredParticipantsDifferent,
  getCoveredParticipantsForAncillaryPlan,
} from 'components/member_onboarding_v2/utils'
import { Banner } from 'slab'
import { type MemberOnboardingMemberPlanChangesProps } from 'utils/web_api.schemas'

export const PartialCoverageWarningBanner = ({
  planChangeSummary,
  coverageType,
  renderedInPlanPage = false,
}: {
  planChangeSummary: MemberOnboardingMemberPlanChangesProps;
  coverageType: 'dental' | 'vision';
  renderedInPlanPage?: boolean;
}) => {
  const nextYearPlan =
    coverageType === 'dental'
      ? planChangeSummary.next_plan_year.dental_plan
      : planChangeSummary.next_plan_year.vision_plan

  // Checks if the plan might be renewed with partial number of dependents
  const overallCoveredParticipants =
    planChangeSummary.next_plan_year.covered_participants || []
  const planCoveredParticipantIds = nextYearPlan?.covered_participant_ids || []
  const showPartialDependentCoverageBanner =
    areCoveredParticipantsDifferent({
      overallCoveredParticipantIds: overallCoveredParticipants.map(
        (participant) => participant.id as string
      ),
      planCoveredParticipantIds,
    }) && !!nextYearPlan

  if (!showPartialDependentCoverageBanner) {
    return null
  }

  const coveredParticipantsForAncillaryPlan =
    getCoveredParticipantsForAncillaryPlan({
      overallCoveredParticipants:
        planChangeSummary.next_plan_year.covered_participants || [],
      planCoveredParticipantIds,
    })

  const banner = (
    <Banner
      title={`Your ${coverageType} plan will cover ${coveredParticipantsForAncillaryPlan} next year.`}
      type='notice'
    />
  )

  if (renderedInPlanPage) {
    return <div className='mt-2'>{banner}</div>
  }

  return banner
}
